import React, { useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from '../../assests/EarthID Logo - Primary - BLACK.png';
import { login } from '../../api/loginAPI';
import { publishToHcs } from '../../api/auditAPI';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.warn('Please enter both email and password');
      return;
    }

    setLoading(true);
    const response = await login({ email, password });
    console.log('this is login response:', response)
    setLoading(false);

    if (response?.jwt) {
      // ✅ Store session
      localStorage.setItem('jwt', response.jwt);
      if (response.user) {
        localStorage.setItem('user', JSON.stringify(response.user));
      }
const messageObj = {
      "event": "Login",
      "message": "User login successful",
      "timestamp": new Date().toISOString(),
      "status": "success"
    }
        await publishToHcs(messageObj)
        console.log('Published audit for login')
      toast.success('Login successful!');
      navigate('/');
    } else {
      toast.error(response?.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="EarthID Logo" className="login-logo" />
        <h2 className="login-title">Welcome</h2>
        <p className="subtitle">Login to your EarthID Dashboard</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>

          <div className="login-actions">
            <span className="forgot-password" onClick={() => navigate('/forgot-password')}>
              Forgot Password?
            </span>
          </div>

          {loading && <div className="loader" />}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>

      {/* Toast messages */}
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </div>
  );
}

export default Login;
